<template>
  <div class="item-checklist p-1 mb-1 border rounded">
    <!--Visualização-->
    <b-row
      v-if="estado === 'visualizacao'"
      align-h="between"
      class="item-detail"
    >
      <b-col
        cols="6"
        class="mb-1"
        @click.stop="edit()"
      >
        <span style="font-size: 14.5px;font-weight: 400;">{{ itemChecklist.descricao }}</span>
      </b-col>
      <b-col
        cols="auto"
        align-self="center"
      >
        <b-btn
          :variant="classRegra"
          class="btn btn-sm mr-1"
          @click="abrirRegra"
        >
          <small
            v-if="obrigatorio"
            class="regra-obrigatoria"
          >*</small> Regras <small class="servico-count">{{ quantidadeServicos }}</small>
        </b-btn>
        <b-btn
          variant="outline-info"
          class="btn btn-sm mr-1"
          @click="edit()"
        >
          <feather-icon icon="Edit2Icon" />
        </b-btn>
        <b-btn
          variant="outline-danger"
          class="btn btn-sm"
          @click.stop="remove()"
        ><feather-icon icon="TrashIcon" /></b-btn>
      </b-col>
    </b-row>
    <!--Edição-->
    <b-row
      v-else
      align-h="between"
      class="mb-50"
    >
      <b-col
        cols="6"
      >
        <b-input
          ref="description"
          v-model="itemChecklist.descricao"
          placeholder="Descreva a pergunta"
          :state="descricaoInvalida !== null ? false:null"
          class="input-sm item-class"
          autofocus
          @keydown.enter.native="adicionarItem"
        />
        <small class="text-danger">{{ descricaoInvalida }}</small>
      </b-col>
      <b-col
        cols="auto"
        align-self="center"
      >
        <b-btn
          :variant="classRegra"
          class="btn btn-sm mr-1"
          @click="abrirRegra"
        >
          <small
            v-if="obrigatorio"
            class="regra-obrigatoria"
          >*</small> Regras <small class="servico-count">{{ quantidadeServicos }}</small>
        </b-btn>
        <b-btn
          variant="outline-danger"
          class="btn btn-sm"
          @click.stop="remove()"
        ><feather-icon icon="TrashIcon" /></b-btn>
      </b-col>
    </b-row>
    <regra-item-checklist
      ref="modalRegra"
      :item-checklist-regra="itemChecklist"
      :tributacao-id="tributacaoSelecionadaId"
      :atividade-id="atividadeSelecionadaId"
      @hide-modal="alterarBotaoRegra($event)"
    />
    <div class="d-flex align-items-center justify-content-start mt-1">
      <b-checkbox
        v-model="itemChecklist.incluirNoContrato"
        class="mb-0 mr-0"
        aria-label="Incluir no contrato"
      />
      <label class="mb-0 ml-0 incluir-label">Incluir no contrato</label>
    </div>
  </div>
</template>

<style lang="scss">
.invalid {
  border-color: #ea5455;
}

.servico-count {
  position: absolute;
  float: right;
  top: 0.4rem;
  padding-left: 0.150rem;
  font-weight: bold;
}

.regra-obrigatoria {
  top: 0.4rem;
  font-weight: bold;
}

.item-class:focus {
  border-color: var(--primary)
}

.incluir-label {
  font-size: 14px;
  margin-bottom: 0;
}
</style>

<script>

export default {
  name: 'ItemChecklist',
  components: {
    RegraItemChecklist: () => import('@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/components/cadastro-regra/RegraItemChecklist.vue'),
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    state: {
      type: String,
      required: true,
      default: 'visualizacao',
    },
    tributacaoId: {
      type: Number,
      default: 0,
    },
    atividadeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      descricaoInvalida: null,
      itemChecklist: this.value,
      estado: '',
      classRegra: 'outline-secondary',
      quantidadeServicos: null,
      obrigatorio: false,
      tributacaoSelecionadaId: 0,
      atividadeSelecionadaId: 0,
    }
  },
  watch: {
    state(value, oldValue) {
      if (value !== oldValue) {
        this.estado = value
      }
    },
    tributacaoId(value, oldValue) {
      if (value !== oldValue) {
        this.tributacaoSelecionadaId = value
      }
    },
    atividadeId(value, oldValue) {
      if (value !== oldValue) {
        this.atividadeSelecionadaId = value
      }
    },
  },
  created() {
    this.itemChecklist = this.value
    this.estado = this.itemChecklist.id === 0 ? 'criacao' : this.state
    this.$set(this.itemChecklist, 'state', this.estado)
    this.tributacaoSelecionadaId = this.tributacaoId
    this.atividadeSelecionadaId = this.atividadeId

    if (this.itemChecklist.servicosItems) {
      const servicos = this.itemChecklist.servicosItems.filter(fil => fil.servico.id > 0)
      const quantidade = servicos.length === 0 ? null : servicos.length
      this.alterarBotaoRegra(quantidade)
    }
  },
  methods: {
    abrirRegra() {
      this.$refs.modalRegra.show()
    },
    remove() {
      this.$emit('remove', this.itemChecklist)
    },
    edit() {
      this.estado = 'edicao'
      this.itemChecklist.state = this.estado

      this.$emit('edicao-atual', this.itemChecklist)
    },
    hasErrors() {
      if (!this.itemChecklist.descricao) {
        this.descricaoInvalida = 'Insira uma descrição'
        return true
      }
      this.descricaoInvalida = null
      return false
    },
    alterarBotaoRegra(count) {
      this.quantidadeServicos = count === 0 ? null : count
      this.obrigatorio = this.itemChecklist.obrigatorioRegra
      if (this.itemChecklist.tipoRegra && (this.itemChecklist.tipoRegra !== 'listasuspensa' && this.itemChecklist.tipoRegra !== 'caixaselecao')) {
        this.classRegra = 'outline-success'
      } else if (this.itemChecklist.tipoRegra && (this.itemChecklist.tipoRegra === 'listasuspensa' || this.itemChecklist.tipoRegra === 'caixaselecao')) {
        const itemServicoIndex = this.itemChecklist.servicosItems.findIndex(fin => !fin.descricao || fin.descricao === '')
        if (itemServicoIndex >= 0 || this.itemChecklist.servicosItems.length === 0) {
          this.obrigatorio = false
          this.classRegra = 'outline-secondary'
        } else {
          this.classRegra = 'outline-success'
        }
      } else {
        this.obrigatorio = false
        this.classRegra = 'outline-secondary'
      }
    },
    adicionarItem() {
      this.$emit('add-item')
    },
  },
}
</script>
